const Env = {
    baseUrl() {
        return process.env.NODE_ENV === 'development'
            ? process.env.REACT_APP_BASEURL_DEV
        : process.env.REACT_APP_BASEURL_PROD;
    },
};

export default Env;
